var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 0.75C1.5 0.335156 1.16484 0 0.75 0C0.335156 0 0 0.335156 0 0.75V8.625C0 9.66094 0.839062 10.5 1.875 10.5H11.25C11.6648 10.5 12 10.1648 12 9.75C12 9.33516 11.6648 9 11.25 9H1.875C1.66875 9 1.5 8.83125 1.5 8.625V0.75ZM11.0297 2.77969C11.3227 2.48672 11.3227 2.01094 11.0297 1.71797C10.7367 1.425 10.2609 1.425 9.96797 1.71797L7.5 4.18828L6.15469 2.84297C5.86172 2.55 5.38594 2.55 5.09297 2.84297L2.46797 5.46797C2.175 5.76094 2.175 6.23672 2.46797 6.52969C2.76094 6.82266 3.23672 6.82266 3.52969 6.52969L5.625 4.43672L6.97031 5.78203C7.26328 6.075 7.73906 6.075 8.03203 5.78203L11.032 2.78203L11.0297 2.77969Z",
    fill: "#9333EA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.d993cd8170b1ecd10e7c553a5507845e.svg";
export { ForwardRef as ReactComponent };